/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./EmojiPlaceholder.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { defaultEmojiHeight } from '../../util/constants';
import { placeholder } from './styles';
var placeholderContainer = null;
export var emojiPlaceholderTestId = function emojiPlaceholderTestId(shortName) {
  return "emoji-placeholder-".concat(shortName);
};
var EmojiPlaceholder = function EmojiPlaceholder(props) {
  var shortName = props.shortName,
    _props$size = props.size,
    size = _props$size === void 0 ? defaultEmojiHeight : _props$size,
    showTooltip = props.showTooltip,
    representation = props.representation,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    xcss = props.xcss;
  var scaledWidth;
  var scaledHeight;
  if (representation && size) {
    var _width = representation.width;
    var _height = representation.height;
    if (_width && _height) {
      scaledWidth = size / _height * _width;
      scaledHeight = size;
    }
  }
  var width = scaledWidth || size;
  var height = scaledHeight || size;
  var style = {
    fill: 'f7f7f7',
    minWidth: "".concat(width, "px"),
    width: "".concat(width, "px"),
    height: "".concat(height, "px")
  };
  return /*#__PURE__*/React.createElement("span", {
    "data-testid": emojiPlaceholderTestId(shortName),
    "aria-busy": loading,
    role: "status",
    "aria-label": shortName
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: ax(["_19pk1n1a _2hwxidpf _otyr1n1a _18u0idpf _2rkofajl _1reo15vq _18m915vq _kqswh2mm _1e0c1o8l _bfhkttw1 _s7n4nkob _o5721q9c _y3gn1h6o", [placeholder, xcss].join(' ')]),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    style: style,
    title: showTooltip ? shortName : ''
  });
};
export default EmojiPlaceholder;